/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 *
 *  @author estelle.giuly
 *
 */
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {WorkflowStatusComponent} from './workflow-status/workflow-status.component';

import {TranslateModule} from '@ngx-translate/core';

import {ClaimElementComponent} from './form/form-element/claim-element/claim-element.component';
import {
  FormDescriptorElementComponent
} from './form/form-element/form-descriptor-element/form-descriptor-element.component';
import {WorkflowFormElementComponent} from './form/form-element/workflow-form-element.component';
import {WorkflowFormComponent} from './form/workflow-form.component';
import {WorkflowV2Service} from './workflow-v2.service';

import {ModalModule} from '@gp/shared/modal/modal.module';
import {MvelModule} from '@gp/shared/mvel/mvel.module';
import { CancelWorkflowModalComponent } from './cancel-workflow-modal/cancel-workflow-modal.component';
import {ApiModule} from '../api/api.module';
import {ClaimsFormModule} from '../claim-form/claim-form.module';
import {EmployeeSelectModule} from '../employee-select/employee-select.module';
import {EmployeesListModule} from '../employees-list/employees-list.module';
import {EmployeesSharedModule} from '../employees/employees-shared.module';
import {FormGeneratorModule} from '../form-generator/form-generator.module';
import {PipesModule} from '../pipes/pipes.module';
import {UiModule} from '../ui/ui.module';
import {ReassignRequestPopupComponent} from './reassign-request-popup/reassign-request-popup.component';

@NgModule({
  imports: [
    ApiModule,
    CommonModule,
    FormsModule,
    PipesModule,
    TranslateModule,
    ReactiveFormsModule,
    UiModule,
    EmployeesSharedModule,
    EmployeesListModule,
    EmployeeSelectModule,
    FormGeneratorModule,
    ClaimsFormModule,
    ModalModule,
    MvelModule
  ],
  providers: [
    WorkflowV2Service
  ],
  declarations: [
    WorkflowFormComponent,
    WorkflowFormElementComponent,
    ClaimElementComponent,
    FormDescriptorElementComponent,
    WorkflowStatusComponent,
    ReassignRequestPopupComponent,
    CancelWorkflowModalComponent
  ],
  exports: [
    WorkflowFormComponent,
    WorkflowFormElementComponent,
    WorkflowStatusComponent,
    ReassignRequestPopupComponent,
    CancelWorkflowModalComponent
  ]
})

export class WorkflowV2Module {
}
